// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__UzQKn","error":"Error_error__9uczQ","btn":"Error_btn__IJNDO"};